"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackOmega = void 0;
/**
 * Creates list of attributes to be included in omega payload.
 */
var getAttributes = function (element) {
    var currentElement = element;
    var attributes = {
        url: window.location.href // eslint-disable-line
    };
    while (currentElement) {
        var dataAttrs = Object.values(currentElement.attributes);
        Object.values(dataAttrs).forEach(function (_a) {
            var nodeName = _a.nodeName, nodeValue = _a.nodeValue;
            if (nodeName.startsWith('data-omega-attribute-') && nodeValue) {
                var attrName = nodeName.replace('data-omega-attribute-', '');
                attributes[attrName] = nodeValue;
            }
        });
        if (currentElement.hasAttribute('data-omega-feature') ||
            currentElement.hasAttribute('data-omega-feature-default')) {
            break;
        }
        currentElement = currentElement.parentElement;
    }
    // add default attributes
    var defaultFeature = getClosestAttribute(element, 'data-omega-feature-default');
    var defaultWidget = getClosestAttribute(element, 'data-omega-widget-default');
    var defaultWidgetType = getClosestAttribute(element, 'data-omega-widget-type-default');
    if (defaultFeature) {
        attributes.defaultFeature = defaultFeature;
    }
    if (defaultWidget) {
        attributes.defaultWidget = defaultWidget;
    }
    if (defaultWidgetType) {
        attributes.defaultWidgetType = defaultWidgetType;
    }
    return { attributes: attributes };
};
/**
 * Gets closest parent with omega props if the target of the click
 * is not the element with omega props.
 */
var getAdjustedTarget = function (element) {
    var omegaElement = element.closest('[data-omega-element]');
    return omegaElement ? omegaElement : element;
};
/**
 * Gets closest parent with the specific omega attribute and returns the value
 * of that attribute if found.
 */
var getHigherAttribute = function (element, attr) {
    var omegaElement = element.closest("[".concat(attr, "]"));
    if (omegaElement) {
        return omegaElement.getAttribute(attr);
    }
};
/**
 * Checks for data attribute on the element. If it doesn't exist, checks up the
 * dom tree to find it.
 */
var getClosestAttribute = function (element, attr) { return element.getAttribute(attr) || getHigherAttribute(element, attr); };
/**
 * Sends an event to OMEGA.
 */
var processEvent = function (targetElement, metrics, debugOn, win) {
    // If the element does not have an element attribute, it is not a valid omega annotation.
    var element = targetElement.getAttribute('data-omega-element');
    if (element) {
        // check for feature
        var feature = getClosestAttribute(targetElement, 'data-omega-feature') ||
            getClosestAttribute(targetElement, 'data-omega-feature-default');
        // check for widget name
        var widgetName = getClosestAttribute(targetElement, 'data-omega-widget') ||
            getClosestAttribute(targetElement, 'data-omega-widget-default');
        // check for widget type
        var widgetType = getClosestAttribute(targetElement, 'data-omega-widget-type') ||
            getClosestAttribute(targetElement, 'data-omega-widget-type-default');
        if (feature && widgetName) {
            // Optional Values
            var customAction = targetElement.getAttribute('data-omega-action');
            var type = targetElement.nodeName.toLowerCase();
            var attributes = getAttributes(targetElement);
            var payload = __assign({ action: customAction || 'click', element: element, feature: feature, type: type, widget: { name: widgetName, type: widgetType || type } }, attributes);
            metrics.analytics.trackEvent(payload);
            // If the debugging query param is present, console the payload
            if (debugOn) {
                console.log(payload); // eslint-disable-line
            }
        }
    }
};
/**
 * Handles events of type 'omega-event', 'pointerup' and 'keydown'.
 * Ensures that Omega event is only sent once for 'omega-event' when a single action
 * triggers multiple events ('omega-event' along with 'pointerup' or 'keydown').
 */
var handleEventFn = function (e, metrics, debugOn, win) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
        return;
    }
    // instanceof must check against the correct global context.
    if (!(e.target instanceof win.HTMLElement)) {
        return;
    }
    var targetElement = e.target;
    // Sometimes the target element is a child of the omega annotated element.
    if (!targetElement.getAttribute('data-omega-element')) {
        targetElement = getAdjustedTarget(targetElement);
    }
    // Prevent duplicate event handling ('omega-event' takes precedence over other event types)
    if (e.type === 'omega-event') {
        // Add a flag attribute to target element to indicate that the 'omega-event' has been handled.
        targetElement.setAttribute('data-omega-handled', 'true');
        processEvent(targetElement, metrics, debugOn, win);
    }
    else {
        // Defer execution when event type is 'pointerup' or 'keydown'
        return win.requestAnimationFrame(function () {
            if (targetElement.getAttribute('data-omega-handled') !== 'true') {
                processEvent(targetElement, metrics, debugOn, win);
            }
            else {
                targetElement.removeAttribute('data-omega-handled');
            }
        });
    }
};
// eslint-disable-next-line no-restricted-globals
function trackOmega(name, win, debugOn, newMetrics) {
    if (name === void 0) { name = 'exc.omega'; }
    if (win === void 0) { win = window; }
    if (debugOn === void 0) { debugOn = false; }
    var metricsApi = (win['exc-module-runtime'] || {}).metrics;
    if (!newMetrics && !metricsApi) {
        throw new Error('Cannot access the Metrics SDK');
    }
    var metrics = newMetrics || metricsApi.create(name);
    var handleEvent = function (e) { return handleEventFn(e, metrics, debugOn, win); };
    win.addEventListener('omega-event', handleEvent, { capture: true });
    win.addEventListener('pointerup', handleEvent, { capture: true });
    win.addEventListener('keydown', handleEvent, { capture: true });
}
exports.trackOmega = trackOmega;
